import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { message } from 'antd';
import { usersAtom } from '../atoms/usersAtom';
import { guardedClient } from '../../auth/api/clients';

export const useIsActive = () => {
  const [users, refresh] = useAtom(usersAtom);

  const updateIsActive = useCallback(
    async (userId: number, isActive: boolean) => {
      try {
        await guardedClient.users[':userId'].$patch({
          param: { userId: userId.toString() },
          json: { isActive },
        });
        message.success('設定を保存しました');
        refresh();
      } catch (error) {
        console.error('保存エラー:', error);
        message.error('保存に失敗しました');
      }
    },
    [refresh]
  );

  return { users, updateIsActive };
};
